import Text from '@deprecated-ui/common/Text';
import { CommentSettingContainer } from '../styled';
import { CommenterState } from '../types';
import CommentSettingItem from './CommentSettingItem';

interface PopoverCommentSettingProps {
  commenter: CommenterState;
  commentSettingList: Array<CommenterState>;
  onChangeCommenter: (data: CommenterState) => void;
}

function PopoverCommentSetting({
  commenter,
  commentSettingList,
  onChangeCommenter,
}: PopoverCommentSettingProps) {
  return (
    <CommentSettingContainer>
      <div>
        <Text weight="700" height="19px" family="bold">
          Who can comment?
        </Text>
        {/* @ts-expect-error */}
        <Text mt="8px" size="12px" weight="400" height="16px">
          Choose who is allowed to comment on this post.
        </Text>
      </div>
      <div>
        {commentSettingList.map((item) => (
          <CommentSettingItem
            {...item}
            key={item.id}
            isActive={commenter.id === item.id}
            onChange={() => onChangeCommenter(item)}
          />
        ))}
      </div>
    </CommentSettingContainer>
  );
}

export default PopoverCommentSetting;
